import { cn } from "@/lib/utils";
import { useTranslation } from "@repo/shared/i18n";

import { checkmarkIcon, chemIcon } from "../../../../../designSystemIcons";
import { convertSummaryStats } from "../../../../../functions/convertValues";
import { MetaRatingLogoSvg } from "../../../../svgs/MetaRatingLogoSvg";

type Props = {
  metaRating: number;
  chemistry: number;
  price: number;
  owned: number;
  onClick: () => void;
  active: boolean;
};
export const SquadSummaryMobile = ({
  metaRating,
  chemistry,
  price,
  owned,
  onClick,
  active,
}: Props) => {
  const { t } = useTranslation(["squadBuilder", "common"]);
  return (
    <div
      className={cn(
        "flex flex-col rounded-l px-1 pb-1 text-xs h-14 rounded border border-white/10",
        active ? "bg-white/20" : "bg-white/10",
      )}
      onClick={onClick}
    >
      <span
        className={cn(
          "mx-auto text-[10px] leading-[14px]",
          active ? "text-white" : "text-gray-300",
        )}
      >
        {t("mobile.overview")}
      </span>
      <div
        className={cn(
          "flex flex-col items-center justify-center h-full rounded px-1",
        )}
      >
        <div className="flex h-4 gap-x-1">
          <div className="flex w-12 gap-x-1">
            <div className="w-4 h-4">
              <MetaRatingLogoSvg bgColor="black" />
            </div>
            <p>{metaRating.toFixed(1)}</p>
          </div>
          <div className="flex gap-x-1 w-9">
            {chemIcon}
            <p>{chemistry}</p>
          </div>
        </div>

        <div className="flex h-4 gap-x-1">
          <div className="flex w-12 gap-x-1">
            <img
              alt={t("common:alt.coin")}
              className="h-4"
              src={
                import.meta.env.VITE_APP_ASSETS_BASE_URL + "/misc/coin-tmp.png"
              }
            />
            <p>{convertSummaryStats(price)}</p>
          </div>
          <div className="flex gap-x-1 w-9">
            {checkmarkIcon}
            <p>{owned}</p>
          </div>
        </div>
      </div>
    </div>
  );
};
